export const prepareError = (error: any): string => {

    if (error.isAxiosError) {
        return `Error ${error.message}`
    }
    if (error && error.errorMessage) {
        return `Error: ${error.errorMessage}`
    }
    if (error && error.response) {
      return `Error ${error.response.status} - ${error.response.statusText}`
    }
    if (error && error.request) {
        return `Error: No response for ${error.response.request}`
      }
    if (error.error && error.error_description) {
      return `Error ${error.error} - ${error.error_description}`
    }
    if (error) {
      return error.toString()
    }
    return "Unknown error occured"
  }

export const prepareErrorFromArray = ( arrError : Array<string>, status:string ): string => {
    return "Status: " + status + " | " + arrError.join(" | ")
} 
  